module.exports = __webpack_public_path__ + "img/50cb4c4.jpg";